import { message } from "@p0security/ui";

export const handleErrorWithToastMessage = (error: string | undefined) => {
  if (error) message.error(error);
};
